var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 515.67 98.15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#0f2c2f;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u56FE\\u5C42_2",
    "data-name": "\\u56FE\\u5C42 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u56FE\\u5C42_1-2",
    "data-name": "\\u56FE\\u5C42 1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "96.09 52.06 96.09 52.06 96.2 51.96 96.09 52.06"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M113.31,89.45A2,2,0,0,1,113.9,88l7.68-7.68-7.68-7.68a2,2,0,0,1-.59-1.41,2,2,0,0,1,.59-1.42l7.68-7.68-7.68-7.68a2,2,0,0,1-.59-1.41,2,2,0,0,1,.59-1.42l6.9-6.9a27,27,0,0,0-24.71,7.31L77,71.16l18.6,18.6.49.49a27,27,0,0,0,24.55,7.35l-6.74-6.74A2,2,0,0,1,113.31,89.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M134.28,52.07a27,27,0,0,0-9.13-6l-7,7,7.57,7.57a2,2,0,0,1,.7,1.52,2,2,0,0,1-.66,1.49l-7.61,7.61,7.57,7.57a2,2,0,0,1,.7,1.52,2,2,0,0,1-.66,1.48l-7.61,7.62L125,96.31a27,27,0,0,0,9.27-44.24Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "46.09 90.25 46.09 90.25 45.99 90.36 46.09 90.25"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M28.88,52.87a2,2,0,0,1-.59,1.42L20.61,62l7.68,7.68a2,2,0,0,1,0,2.82l-7.68,7.68,7.68,7.69a2,2,0,0,1,0,2.82l-6.9,6.91a27,27,0,0,0,24.7-7.32l19.1-19.09-18.6-18.6-.5-.49a26.93,26.93,0,0,0-24.54-7.35l6.74,6.74A2,2,0,0,1,28.88,52.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M7.91,90.25a26.89,26.89,0,0,0,9.13,6l7-7-7.57-7.57a2,2,0,0,1,0-3l7.61-7.61-7.57-7.57a2,2,0,0,1,0-3l7.61-7.61L17.18,46A27,27,0,0,0,7.91,90.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M89.93,7.91A27,27,0,0,0,51.74,46.09l19.1,19.1,18.6-18.6.49-.5A27,27,0,0,0,89.93,7.91ZM70.84,39.66a12,12,0,1,1,12-12A12,12,0,0,1,70.84,39.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M167,.48l30.73,0q12.31,0,12.32,12.32V40.75q0,7.17-5.78,7.64,5.78.95,5.77,7.18V85.21q0,12.32-12.33,12.32H167Zm32.26,83v-26c0-2-.31-3.28-.94-3.9s-1.92-.94-3.9-.94H177.76V88.32h16.69c2,0,3.28-.28,3.9-.86S199.28,85.57,199.28,83.49Zm0-44.93v-24c0-2.08-.31-3.41-.93-4s-1.93-.86-3.9-.86H177.78v33.7h16.69c2,0,3.27-.28,3.9-.85S199.29,40.64,199.3,38.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M237.18,88.34h26.68v9.2H226.42l0-97H262.8v9.2H237.21V42.47h20.91v9.21H237.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M286.32,88.36H313v9.2H275.55l0-97h36.35v9.2H286.35V42.49h20.9v9.21h-20.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M335.32,57l0,40.56H324.69l0-97H353q12.33,0,12.32,12.33V44.71q0,11.07-9.68,12.16l14.65,40.72H358.7L344.52,57Zm0-47.27V47.82h14.51c2.08,0,3.4-.28,4-.86s.86-1.89.86-4l0-28.4c0-2.07-.29-3.4-.86-4s-1.9-.86-4-.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M392.24,88.4h26.68v9.2H381.47l0-97h36.35v9.2H392.27V42.53h20.9v9.21h-20.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M456.05,83.59V57.07c0-2.08-.31-3.41-.94-4s-1.92-.86-3.9-.86H440.61q-12.32,0-12.32-12.33v-27Q428.32.58,440.63.59h13.73q12.33,0,12.32,12.33v15H455.91V14.63c0-2.08-.29-3.4-.86-4s-1.9-.86-4-.86h-7.17c-2.09,0-3.41.29-4,.86s-.86,1.9-.86,4V38.18c0,2,.28,3.28.86,3.9s1.89.94,4,.94H454.5q12.33,0,12.32,12.32V85.3q0,12.33-12.33,12.33H440.91q-12.33,0-12.32-12.33v-15h10.77V83.58c0,2.08.29,3.41.86,4s1.9.86,4,.86h7c2,0,3.27-.28,3.9-.86S456,85.67,456.05,83.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M515.67.62v9.2h-15.6l0,87.83H489.42l0-87.83h-15.6V.6Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.6f31760df1eecc2a6f5ef80a07beddfe.svg";
export { ForwardRef as ReactComponent };